import { messenger } from '@communication'
import { remoteStream } from '@stream'

export default class StreamProcedure {
  constructor() {
    this.name = 'streamProcedure'
  }

  install = () => {
    messenger.subscribe(this.name, ['strategy:stream:video'], this.handlerVideo)
    messenger.subscribe(this.name, ['strategy:stream:audio'], this.handlerAudio)
  }

  uninstall = () => {
    messenger.unsubscribe(this.name)
  }

  handlerVideo = (event) => {
    const { stream } = event
    remoteStream.video.value = stream
  }
  handlerAudio = (event) => {
    const { stream } = event
    remoteStream.audio.value = [...remoteStream.audio.value, stream]
  }
}
